import React, { useState, useEffect } from "react";
import style from "./index.module.css";
import { UserService } from "../../services/UserService";

const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    window.location.href = "/login";
};

export default function MyAccount() {
    const [visibleDiv, setVisibleDiv] = useState(1);
    const [user, setUser] = useState(null);
    const [isEditing, setIsEditing] = useState(false); 
    const [updatedUser, setUpdatedUser] = useState({}); 
    const [orders, setOrders] = useState([]); 
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem("user"));
                if (!storedUser || !storedUser.userId) return;

                const userData = await UserService.getUserById(storedUser.userId);
                setUser(userData);
                setUpdatedUser(userData);

                const userOrders = await UserService.getUserOrders(storedUser.userId);
                console.log(userData)
                setOrders(userOrders); 
            } catch (error) {
                console.error("Error fetching user details:", error);
                if (error.response?.status === 401) {
                    handleLogout();
                }
            }
        };
        fetchUserData();
    }, []);

    const handleEditClick = () => {
        setIsEditing(true); 
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setUpdatedUser(user);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUpdatedUser((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSaveClick = async () => {
        try {
            await UserService.updateUser(user.userId, updatedUser);
            setUser(updatedUser);
            setIsEditing(false); 
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };

    if (!user) {
        return <p>Loading...</p>;
    }

    return (
        <div>
            <div className={style.contact}>
                <div className={style.our}>
                    <p><a href="/Home">Home</a>/<span>My Account</span></p>
                    <h1>Contact With Us</h1>
                </div>
                <div className={style.img}>
                    <img src="https://new.axilthemes.com/demo/template/etrade/assets/images/product/product-45.png" alt="Banner" />
                </div>
            </div>
            <div className={style.img1}>
                <img src={user?.userFoto} alt="User" />
                <h1>Hello {user?.userName}</h1>
                <p>eTrade Member Since Sep 2020</p>
            </div>
            <div className={style.det}>
                <div className={style.div1}>
                    <button onClick={() => setVisibleDiv(1)}>
                        <i className="fas fa-th-large"></i>Dashboard
                    </button>
                    <button onClick={() => setVisibleDiv(2)}>
                        <i className="fas fa-shopping-basket"></i>Orders
                    </button>
                    <button onClick={() => setVisibleDiv(3)}>
                        <i className="fas fa-user"></i>Account Details
                    </button>
                    <button onClick={handleLogout} className={style.btn}>
                        <i className="fa-solid fa-arrow-right-from-bracket"></i>LogOut
                    </button>
                </div>

                {/* Dashboard */}
                <div className={style.text} style={{ display: visibleDiv === 1 ? "block" : "none" }}>
                    <h6>Hello {user?.userName} (not <span>{user?.userName}?</span> <button onClick={handleLogout}>LogOut</button>)</h6>
                    <p>From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.</p>
                </div>
                
                {/* Orders */}
                <div className={style.order} style={{ display: visibleDiv === 2 ? "block" : "none" }}>
                    <table className="table mt-3">
                        <thead className={style.thead}>
                            <tr>
                                <th>Order</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.length > 0 ? (
                                orders.map((order, index) => (
                                    <tr key={index}>
                                        <td>#{order.orderId}</td>
                                        <td>{new Date(order.orderDate).toLocaleDateString()}</td>
                                        <td>{order.orderLevelName}</td>
                                        <td>${order.totalPrice}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No orders found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Account Details */}
                <div className={style.acc} style={{ display: visibleDiv === 3 ? "block" : "none" }}>
                    <p>Update Info <i className="fa-solid fa-pen-to-square" onClick={handleEditClick}></i></p>
                    {isEditing ? (
                        <div>
                            <div>
                                <label>Name:</label>
                                <input
                                    type="text"
                                    name="userName"
                                    value={updatedUser.userName}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                <label>Full Name:</label>
                                <input
                                    type="text"
                                    name="userFullName"
                                    value={updatedUser.userFullName}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                <label>Email:</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={updatedUser.email}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                <label>Gender:</label>
                                <input
                                    type="text"
                                    name="userGender"
                                    value={updatedUser.userGender}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <button onClick={handleSaveClick}>Save</button>
                            <button onClick={handleCancelClick}>Cancel</button>
                        </div>
                    ) : (
                        <div>
                            <p><span>Name: </span>{user?.userName}</p>
                            <p><span>Full Name: </span>{user?.userFullName}</p>
                            <p><span>Email: </span>{user?.email}</p>
                            <p><span>Gender: </span>{user?.userGender}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
